import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import {
  InventoryAutomotiveItem,
  InventoryAutomotiveState
} from '@/modules/inventory/inventoryAutomotive/types/types.ts'

const initialState: InventoryAutomotiveState = {
  selected: undefined,
  isOpenModal: false,
  isDeleteModalOpen: false
}

const inventoryAutomotiveSlice = createSlice({
  name: 'inventoryAutomotives',
  initialState,
  reducers: {
    setSelected: (
      state,
      action: PayloadAction<InventoryAutomotiveItem | undefined>
    ) => {
      state.selected = action.payload
    },
    setOpenModal: (state, action: PayloadAction<boolean>) => {
      state.isOpenModal = action.payload
    },
    setDeleteOpenModal: (state, action: PayloadAction<boolean>) => {
      state.isDeleteModalOpen = action.payload
    }
  }
})

export const inventoryAutomotivesActions = inventoryAutomotiveSlice.actions
export const { reducer: inventoryAutomotivesReducer } = inventoryAutomotiveSlice
